var map = {
	"./ADA.png": "9a39",
	"./ARS.png": "713e",
	"./ATOM.png": "277e",
	"./AUD.png": "9c6a",
	"./AVAX.png": "ceed",
	"./BCH.png": "b191",
	"./BNB.png": "65b8",
	"./BTC.png": "0b53",
	"./CAD.png": "0872",
	"./CHF.png": "8183",
	"./CNY.png": "a571",
	"./CZK.png": "03d7",
	"./DOGE.png": "026c",
	"./DOT.png": "ebbb",
	"./ETC.png": "c959",
	"./ETH.png": "6ab1",
	"./EUR.png": "3bfc",
	"./GBP.png": "589e",
	"./HBAR.png": "76ee",
	"./JPY.png": "d7b6",
	"./KGS.png": "7350",
	"./KZT.png": "bd2d",
	"./LINK.png": "e9c2",
	"./LTC.png": "5c1b",
	"./MATIC.png": "e6ef",
	"./NCT.png": "93b3",
	"./NEAR.png": "f912",
	"./NZD.png": "15bd",
	"./PLN.png": "4ac0",
	"./RON.png": "c7ed",
	"./RUB.png": "9188",
	"./SEK.png": "072a",
	"./SGD.png": "fdf6",
	"./SHIB.png": "17db",
	"./SOL.png": "606a",
	"./SOLUSDC.png": "c28f",
	"./SOLUSDT.png": "501d",
	"./TON.png": "997f",
	"./TRX.png": "d3ac",
	"./TRY.png": "374f",
	"./UNI.png": "3107",
	"./USD.png": "3534",
	"./USDC-ERC20.png": "e288",
	"./USDC.png": "c8e6",
	"./USDCE.png": "3a7b",
	"./USDCT.png": "3a341",
	"./USDT-ERC20.png": "dbc5",
	"./USDT-TRC20.png": "40e7",
	"./USDT.png": "1d59",
	"./USDTE.png": "9110",
	"./USDTT.png": "8714",
	"./USDTTRC.png": "eb57",
	"./UZS.png": "d775",
	"./XAU.png": "0a12",
	"./XLM.png": "a96f",
	"./XMR.png": "f91e",
	"./XRP.png": "9fee",
	"./ZAR.png": "39c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c37";